﻿import document from 'document';
import { specialOffersDropdown } from './offers-dropdown';
import { specialOffersFiltersDropdown } from './offers-filters';

export const specialOffers = () => {
    let dropdowns = [];
    const illustrationsCallbackUrl = '/api/offers/illustrations';
    const filtersCallbackUrl = '/api/offers/getfilterresults';
    const sortByParameter = 'sortBy';
    const filtersParameter = 'filters';
    const dataSourceIdParameter = 'dataSourceId';
    const pageIdParameter = 'pageId';
    const cardsContainer = document.querySelector('[data-illustrations]');
    let filtersSelected = {};
    let sortBySelected = null;
    let filterDropdowns = [];

    const filters = () => {
        return [...dropdowns.map(d => d.elem.querySelector('dropdown__placeholder'))];
    };

    const onOptionSelected = (optionToSelect) => {
        sortBySelected = optionToSelect.value;
        refresh();
    };

    const addFilter = (key, blsKey, currentKeys) => {
        if (currentKeys.includes(blsKey) && !filtersSelected[blsKey].split(',').includes(key)) {
            filtersSelected[blsKey] = filtersSelected[blsKey].concat(',', key);
        } else {
            filtersSelected[blsKey] = key;
        }
    };

    const removeFilter = (key, blsKey, currentKeys) => {
        if (currentKeys.includes(blsKey)) {
            if (filtersSelected[blsKey].split(',').includes(key)) {
                filtersSelected[blsKey] = filtersSelected[blsKey].split(',').filter(x => x !== key).join(',');
                if (filtersSelected[blsKey].length === 0) {
                    delete filtersSelected[blsKey];
                }
            } else if (filtersSelected[blsKey].includes('Y')) {
                delete filtersSelected[blsKey];
            }
        }
    };

    const fixCarTypeBlsValues = () => {
        Object.keys(filtersSelected).forEach(function (key) {
            if (key.includes('carType')) {
                filtersSelected[key] = 'Y';
            }
        });
    };
    const onFilterTicked = (e) => {
        let key = e.currentTarget.getAttribute('key');
        let blsKey = e.currentTarget.getAttribute('blsKey');
        let currentKeys = Object.keys(filtersSelected);
        if (e.currentTarget.checked) {
            addFilter(key, blsKey, currentKeys);
        } else {
            removeFilter(key, blsKey, currentKeys);
        }
        fixCarTypeBlsValues();
        refresh();
    };

    const createDropdown = node => {
        const dropdown = new specialOffersDropdown(node, onOptionSelected);
        const selectedOption = dropdown.getSelectedOption();

        if (selectedOption) {
            sortBySelected = selectedOption.value;
        }
    };

    const createFiltersDropdown = node => {
        const filter = new specialOffersFiltersDropdown(node, onFilterTicked);
        let currentKeys = Object.keys(filtersSelected);

        for (var i = 0; i < filter.checkboxes.length; i++) {
            const input = filter.checkboxes[i];
            const checked = input.checked;

            if (checked) {
                const blsKey = input.getAttribute('blsKey');
                const key = input.getAttribute('key');
                addFilter(key, blsKey, currentKeys);
            }
        }

        fixCarTypeBlsValues();

        filterDropdowns.push(filter);
    };

    const getCallbackUrl = (callbackUrl) => {
        const datasourceId = document.getElementById('DatasourceId').value;
        const pageId = document.getElementById('PageId').value;
        let urlParameters = getUrlParameters();
        urlParameters.append(pageIdParameter, pageId);
        urlParameters.append(dataSourceIdParameter, datasourceId);
        setPageQueryString();
        return `${callbackUrl}?${urlParameters.toString()}`;
    };

    const getFilters = () =>
        Object.entries(filtersSelected).map(([k, v]) => (`${k}=${v}`)).join('#');

    const getUrlParameters = () => {
        let urlParameters = new URLSearchParams();
        if (sortBySelected) {
            urlParameters.append(sortByParameter, sortBySelected);
        }

        const filters = getFilters();

        if (filters) {
            urlParameters.append(filtersParameter, filters);
        }

        return urlParameters;
    };

    const setPageQueryString = () =>
        window.history.replaceState({}, '', `${window.location.pathname}?${getUrlParameters().toString()}`);

    const refresh = () => {
        toggleFilter(true);
        fetch(getCallbackUrl(illustrationsCallbackUrl), {
            method: "GET"
        }).then((response) => {
            return response.text();
        }).then(function (data) {
            cardsContainer.innerHTML = data;
            refreshFilters();
        }).catch(error => {
            toggleFilter(false);
            console.log(error);
        });
    };

    const refreshFilters = () => {
        fetch(getCallbackUrl(filtersCallbackUrl), {
            method: "GET"
        }).then((response) => {
            return response.json();
        }).then(function (data) {
            setFilters(data);
            toggleFilter(false);
        }).catch(error => {
            toggleFilter(false);
            console.log(error);
        });
    };

    const setFilters = (filterValues) => {
        filterDropdowns.forEach((f) => {
            f.updateCount(filterValues);
        });
    };

    const toggleFilter = (show) => {
        const overlay = document.getElementsByClassName('offer-module__overlay')[0];
        const loader = document.getElementsByClassName('offer-module__loader')[0];

        overlay.style.display = show ? 'block' : 'none';
        loader.style.display = show ? 'block' : 'none';
    };

    const init = () => {
        const dropdownNodes = [...document.querySelectorAll('[data-component="offers-dropdown"]')];
        const filterNodes = [...document.querySelectorAll('[data-component="offers-filters"]')];
        dropdowns = dropdownNodes.map(createDropdown);
        dropdowns.push(filterNodes.map(createFiltersDropdown));
    };

    return {
        init,
        filters
    };
};
specialOffers.selectors = {
    root: "[data-component='offer-module']"
};